module.exports = __webpack_public_path__ + "static/media/paragraph.109eeba1.svg";